export default "__VITE_ASSET__CYPEd7CO__"